import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/{store}` → that store's overview. */
export const Route = createFileRoute("/_authenticated/$store/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$store/overview", params, replace: true });
  },
});
